import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BoydRedeemRewardsComponent } from './boyd-redeem-rewards.component';



@NgModule({
  declarations: [BoydRedeemRewardsComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    BoydRedeemRewardsComponent
  ]
})
export class BoydRedeemRewardsModule { }
